export function findOwnedAccountId(accounts = [], accountId = "") {
  const normalizedAccountId = String(accountId || "").trim();
  return normalizedAccountId && accounts.some((account) => String(account?.id || "").trim() === normalizedAccountId)
    ? normalizedAccountId
    : "";
}

export function resolveOwnedAccountId(accounts = [], {
  queryAccountId = "",
  storedAccountId = "",
  primaryAccountId = "",
  fallbackAccountId = "",
} = {}) {
  return findOwnedAccountId(accounts, queryAccountId)
    || findOwnedAccountId(accounts, storedAccountId)
    || findOwnedAccountId(accounts, primaryAccountId)
    || findOwnedAccountId(accounts, fallbackAccountId)
    || "";
}

export function resolveFreshOwnedAccountId(payload = null, storedAccountId = "") {
  const accounts = Array.isArray(payload?.accounts) ? payload.accounts : [];
  return findOwnedAccountId(accounts, storedAccountId)
    || findOwnedAccountId(accounts, payload?.primaryAccountId)
    || findOwnedAccountId(accounts, payload?.billingAccountId)
    || String(accounts[0]?.id || "").trim();
}
